const PREFIX = 'adas';

export const SPARTAN_PRODUCT_ADAS_TRACKING = {
  section: PREFIX,
  banner: `${PREFIX}-banner`,
  bannerImage: `${PREFIX}-banner-image`,
  header: `${PREFIX}-header`,
  eyebrow: `${PREFIX}-eyebrow`,
  title: `${PREFIX}-title`,
  description: `${PREFIX}-description`,
  cta: `${PREFIX}-cta`,
} as const;

export const SPARTAN_PRODUCT_ADAS_DATA_GA = {
  section: PREFIX,
} as const;
